// lazy component loading
const ContestsList = () => import(/* webpackChunkName: "contestdream" */ './ContestsList.vue');
const ContestsDashboard = () => import(/* webpackChunkName: "contestdream" */ './ContestsDashboard.vue');
const Contest = () => import(/* webpackChunkName: "contestdream" */ './Contest.vue');

//new contest
const NewContest = () => import(/* webpackChunkName: "contestdream" */ './NewContest.vue');

//one contest
const Overview = () => import(/* webpackChunkName: "contestdream" */ './contest/Overview.vue');
const Participations = () => import(/* webpackChunkName: "contestdream" */ './contest/Participations.vue');
const Participation = () => import(/* webpackChunkName: "contestdream" */ './contest/participations/Show.vue');

const Terms = () => import(/* webpackChunkName: "contestdream" */ './contest/Terms.vue');
const Tos = () => import(/* webpackChunkName: "contestdream" */ './contest/Tos.vue');

const Reports = () => import(/* webpackChunkName: "contestdream" */ './contest/Reports.vue');

const Edit = () => import(/* webpackChunkName: "contestdream" */ './contest/Edit.vue');
const End = () => import(/* webpackChunkName: "contestdream" */ './contest/End.vue');

const Questions = () => import(/* webpackChunkName: "contestdream" */ './contest/partypes/Questions.vue');
const Simple = () => import(/* webpackChunkName: "contestdream" */ './contest/partypes/Simple.vue');
const Codes = () => import(/* webpackChunkName: "contestdream" */ './contest/partypes/Codes.vue');
const Twitter = () => import(/* webpackChunkName: "contestdream" */ './contest/partypes/Twitter.vue');

import tutorialsteps from './tutorial';
import {routerTutorialGuard} from '@/providers/tutorial'

//ROUTES

export const routes = [{
  path: 'contestdream',
  redirect: {name: 'contestdream.dashboard'},
  name: 'contestdream',
  //empty component just for base
  component: {template: '<router-view/>'},
  meta: {
    trans: 'contestdream:title',
    root: true,
  },
  children: [
    //DASHBOARD
    {
      path: 'dashboard',
      name: 'contestdream.dashboard',
      component: ContestsDashboard,
      meta: {
        trans: 'contestdream:titles.dashboard',
        icon: 'contestdream.logo',
      }
    },
    //CONTESTS LIST
    {
      path: 'contests',
      name: 'contestdream.list',
      component: ContestsList,
      meta: {
        trans: 'contestdream:titles.contests',
        icon: 'medal',
      },
    },
    //NEW CONTEST
    {
      path: 'new',
      name: 'contestdream.new',
      component: NewContest,
      meta: {
        trans: 'contestdream:contests.add_new',
        up: 'contestdream.list',
      },
    },
    //SINGLE CONTEST VIEW
    {
      name: 'contestdream.contest',
      path: 'contests/:id',
      component: Contest,
      props: true,
      redirect: {name: 'contestdream.contest.dashboard'},
      meta: {
        trans: 'contestdream:titles.contest',
        up: 'contestdream.list',
        root: true,
      },
      children: [
        {
          path: 'dashboard',
          component: Overview,
          name: 'contestdream.contest.dashboard',
          meta: {
            icon: 'home',
            trans: 'contestdream:contests.titles.dashboard',
          },
        },
        {
          path: 'edit',
          component: Edit,
          name: 'contestdream.contest.edit',
          meta: {
            icon: 'pencil',
            trans: 'contestdream:contests.titles.settings',
          },
        },
        //PARTICIPATIONS TYPES
        {
          path: 'questions',
          component: Questions,
          name: 'contestdream.contest.questions',
          meta: {
            icon: 'contestdream.question',
            trans: 'contestdream:questions.title',
          },
        },
        {
          path: 'limit',
          component: Simple,
          name: 'contestdream.contest.simple',
          meta: {
            icon: 'contestdream.cursor',
            trans: 'contestdream:contests.partypes.simple',
          },
        },
        {
          path: 'codes',
          component: Codes,
          name: 'contestdream.contest.codes',
          meta: {
            icon: 'contestdream.qr',
            trans: 'contestdream:contests.partypes.types.unique_codes',
          },
        },
        {
          path: 'hashtag',
          component: Twitter,
          name: 'contestdream.contest.twitter',
          meta: {
            icon: 'contestdream.twitter',
            trans: 'contestdream:contests.partypes.types.twitter',
          },
        },
        //end PARTICIPATIONS TYPES
        {
          path: 'terms',
          name: 'contestdream.contest.terms',
          component: Terms,
          meta: {
            icon: 'document',
            trans: 'contestdream:contests.titles.terms',
          },
          children: [
            {
              path: ':tosid',
              name: 'contestdream.contest.terms.show',
              props: true,
              component: Tos,
            },
          ],
        },
        {
          path: 'participations',
          name: 'contestdream.contest.participations',
          component: Participations,
          meta: {
            icon: 'human',
            trans: 'contestdream:contests.titles.participations',
          },
          children: [
            {
              path: ':participations_id',
              name: 'contestdream.contest.participations.show',
              props: true,
              component: Participation,
            }
          ],
        },
        {
          path: 'reports',
          name: 'contestdream.contest.reports',
          component: Reports,
          meta: {
            icon: 'bargraph',
            trans: 'contestdream:contests.titles.reports',
          },
        },
        {
          path: 'finalize',
          name: 'contestdream.contest.finalize',
          component: End,
          meta: {
            icon: 'trophy',
            trans: 'contestdream:contests.finalize.title',
          },
        },
      ],
    },
  ],
}];

// TRANSLATIONS
import en from './i18n/en'
import it from './i18n/it'
import sl from './i18n/sl'
import de from './i18n/de'
import fr from './i18n/fr'
import i18n from '@/providers/i18n'

for (let [lang, bundle] of Object.entries({en, it, sl, de, fr})) {
  i18n.i18next.addResourceBundle(lang, 'contestdream', bundle);
}

export function guard(router) {
  router.afterEach((to, from) => {
    if (to.name && to.name.split('.')[0] === 'contestdream') {
      import(/* webpackChunkName: "contestdream" */ './scss/style.scss');
    }
  });
  routerTutorialGuard(router, 'contestdream', 'admin-contestdream-tutorial', tutorialsteps);
}


// WEBPACK FOOTER //
// ./src/apps/contestdream/index.js